import styles from './style.module.css';

import { Markup } from 'interweave';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from '../../components/layouts/Layout';
import { Navbar } from '../../components/layouts/Navbar';
import { useAuth } from '../../hooks/useAuth';
import { api } from '../../server/api';
import { getUrlClient } from '../../utils/getUrlClient';

export function Terms() {
  const location = useLocation();
  const { playerAuth } = useAuth();
  const [client, setClient] = useState<any>();
  const [termsContent, setTermsContent] = useState<string>();
  const [termsImage, setTermsImage] = useState<string | undefined>();
  const [locationClientId, setLocationClientId] = useState<string>();

  useEffect(() => {
    getClientByUrl();
  }, []);

  useEffect(() => {
    getClientTerms();
  }, [client]);

  const getClientByUrl = async () => {
    try {
      const methodGet: any = getUrlClient();

      const parameters = {
        searchFunctionality: 'getClientByAlias',
        userType: 'player',
        clientAlias: methodGet?.link,
        isUrl: false,
      };

      const responseClientAlias = await api.post(`/search`, parameters);

      setClient(responseClientAlias.data.data.client);
    } catch (error) {
      console.log('getClientByUrl error: ', error);
    }
  };

  const getClientTerms = async () => {
    // clientId pela URL permite abrir os termos em nova aba (sem location.state)
    const clientIdParam = new URLSearchParams(location.search).get('clientId');
    const valueClientId =
      clientIdParam ||
      (location.state && location.state.isCameFromActionPage
        ? location.state.clientId
        : client && client.id);
    setLocationClientId(valueClientId);
    try {
      const parameters = {
        searchFunctionality: 'getClientTerms',
        userType: 'player',
        clientId: valueClientId,
      };

      const responseClientTerms = await api.post('/search', parameters);

      const { data } = responseClientTerms;
      if (data.success) {
        setTermsContent(data.data.htmlString);
        setTermsImage(
          data.data.termsImage !== '' ? data.data.termsImage : false
        );
      }
    } catch (error) {
      console.log('error getClientTerms-->', error);
    }
  };

  if (!playerAuth || (client && client.id !== locationClientId)) {
    return (
      <Layout>
        <div className={`container ${styles.bodyHeight}`}>
          <div className="container">
            <div className="container">
              <div className="row">
                {termsContent && termsImage && termsContent!.length > 0 && (
                  <>
                    <div className="col-sm-12">
                      <div className="my-3">
                        <img
                          className="img-fluid"
                          src={termsImage && termsImage}
                        />
                      </div>
                      <div className="my-3">
                        <Markup content={termsContent} />
                      </div>
                    </div>
                  </>
                )}

                {termsContent && !termsImage && termsContent!.length > 0 && (
                  <>
                    <div className="col-sm-12">
                      <div className="my-3">
                        <Markup content={termsContent} />
                      </div>
                    </div>
                  </>
                )}

                {termsContent && termsContent!.length === 0 && (
                  <>
                    <div className="col-sm-12">
                      <div className="d-flex justify-content-center">
                        <div className="my-3">
                          <p className="fs-4 fw-semibold text-center">
                            Ops!...
                          </p>
                          <span className="text-center">
                            Nenhum termo cadastrado ainda!
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Navbar>
      <div className="container">
        <div className="container">
          <div className="row">
            {termsContent && termsImage && termsContent!.length > 0 && (
              <>
                <div className="col-sm-12">
                  <div className="my-3">
                    <img className="img-fluid" src={termsImage && termsImage} />
                  </div>
                  <div className="my-3">
                    <Markup content={termsContent} />
                  </div>
                </div>
              </>
            )}

            {termsContent && !termsImage && termsContent!.length > 0 && (
              <>
                <div className="col-sm-12">
                  <div className="my-3">
                    <Markup content={termsContent} />
                  </div>
                </div>
              </>
            )}

            {termsContent && termsContent!.length === 0 && (
              <>
                <div className="col-sm-12">
                  <div className="d-flex justify-content-center">
                    <div className="my-3">
                      <p className="fs-4 fw-semibold text-center">Ops!...</p>
                      <span className="text-center">
                        Nenhum termo cadastrado ainda!
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Navbar>
  );
}
